import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  constructor(private http: HttpClient) {}

  findGroupWithUser(keyword: string = null, groupId: string = null): Observable<any> {
    let params: HttpParams = new HttpParams();

    if (keyword != null) params = params.set('keyword', keyword);
    if (groupId != null) params = params.set('groupId', groupId);

    const url = `${environment.url.api}/searches/group-with-user`;

    return this.http
      .get<any>(url, { params })
      .pipe(timeout(environment.config.apiWaitingTime));
  }
}
